import { Tooltip, Typography } from "@mui/material";
import CustomDialog from "../../../elements/CustomDialog";
import { capitalizeWords } from "../../../utils/helpers";
import StatusChip from "../../../elements/StatusChip";
import CustomTable from "../../../components/table/CustomTable";
import { useStyles } from "./styles";

const AccountSummary = ({ summary, label, onClose }) => {
  const classes = useStyles();
  const isCost = label === "cost";
  const costColumns = [
    { field: "service", label: "Service" },
    {
      field: "cost",
      label: "Cost",
      align: "right",
      headerAlign: "right",
      render: (row) => (
        <Typography variant="body2" title={row.cost}>
          ${parseFloat(row.cost.toFixed(4))}
        </Typography>
      ),
    },
  ];

  const SecurityColumns = [
    {
      field: "title",
      label: "Title",
      align: "left",
      render: (row) => (
        <Tooltip arrow title={row.description}>
          {row.title}
        </Tooltip>
      ),
    },
    { field: "age", align: "left", label: "Age" },
    {
      field: "severity",
      label: "Severity",
      render: (row) => {
        return <StatusChip status={row?.severity} />;
      },
    },
    { field: "region", label: "Region" },
    { field: "accountId", align: "left", label: "Account" },
  ];

  return (
    <CustomDialog
      open={Boolean(summary)}
      title={`${capitalizeWords(label)} Overview`}
      onClose={onClose}
    >
      {summary && (
        <CustomTable
          columns={isCost ? costColumns : SecurityColumns}
          data={summary}
          headerClass={classes.tableHeaderClass}
          variant="secondary"
        />
      )}
    </CustomDialog>
  );
};

export default AccountSummary;
